import { EvidenceSubmissionParams } from '@/backend/access/evidenceSubmission/types';

export enum SubmitterOutcome {
  PASSED = 'passed',
  FAILED = 'failed',
  DEVIATED = 'deviated',
  PENDING = 'pending',
}

export enum ReviewerOutcome {
  APPROVED = 'approved',
  REJECTED = 'rejected',
}

export class EvidenceSubmission {
  id: string;
  createdAt?: Date | string;
  updatedAt?: Date | string;
  requirementId: string;
  evidenceCategoryId: string;
  evidenceItemId: string;
  propelOrgId: string;
  submitterOutcome: SubmitterOutcome;
  reviewerOutcome?: ReviewerOutcome | null;
  submittedBy: string;
  submittedAt: string;
  reviewedBy?: string | null;
  reviewedAt?: string | null;
  title: string;
  description?: string | null;
  reviewComment: string;

  constructor(params: EvidenceSubmissionParams) {
    this.id = params.id;
    this.createdAt = params.createdAt;
    this.updatedAt = params.updatedAt;
    this.requirementId = params.requirementId;
    this.evidenceCategoryId = params.evidenceCategoryId;
    this.evidenceItemId = params.evidenceItemId;
    this.propelOrgId = params.propelOrgId;
    this.submitterOutcome = params.submitterOutcome;
    this.reviewerOutcome = params.reviewerOutcome;
    this.submittedBy = params.submittedBy;
    this.submittedAt = params.submittedAt;
    this.reviewedBy = params.reviewedBy;
    this.reviewedAt = params.reviewedAt;
    this.title = params.title;
    this.description = params.description;
    this.reviewComment = params.reviewComment || '';
  }
}
